export default "__VITE_ASSET__Bs9udg3P__"